import { Hero } from "@/components/Hero";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
} from "@/components/ui/alert-dialog";

const Closed = ({ message }: { message: string }) => (
  <AlertDialog open={true}>
    <AlertDialogContent className="px-0">
      <Hero showModeIndicator={false} showAddress />
      <AlertDialogHeader className="font-medium tracking-tighter text-left px-4">
        Sorry, we're not taking online orders at the moment.
      </AlertDialogHeader>
      <div className="whitespace-pre-line text-left text-sm text-muted-foreground px-4 flex flex-col gap-y-2">
        <p>{message}</p>
        <p>
          If you believe this is an error, please order inside or contact staff.
        </p>
      </div>
    </AlertDialogContent>
  </AlertDialog>
);

export default Closed;
